// AI-generated with Claude Code.
import { useState } from 'react'
import { EMOJI_GROUPS, groupForEmoji, searchEmojis } from '../lib/emojis'

export function EmojiPicker({ value, onChange }: { value: string; onChange: (emoji: string) => void }) {
  const [groupId, setGroupId] = useState(() => groupForEmoji(value))
  const [query, setQuery] = useState('')
  const group = EMOJI_GROUPS.find((candidate) => candidate.id === groupId) ?? EMOJI_GROUPS[0]

  const searching = query.trim().length > 0
  const emojis = searching ? searchEmojis(query) : group.emojis.map(([emoji]) => emoji)

  return (
    <div className="emoji-picker">
      <input
        type="search"
        className="input"
        placeholder="Search emoji"
        aria-label="Search emoji"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      {searching ? null : (
        <div className="emoji-tabs" role="tablist" aria-label="Emoji categories">
          {EMOJI_GROUPS.map((candidate) => (
            <button
              key={candidate.id}
              type="button"
              role="tab"
              aria-selected={candidate.id === group.id}
              className={`chip${candidate.id === group.id ? ' chip-on' : ''}`}
              onClick={() => setGroupId(candidate.id)}
            >
              {candidate.label}
            </button>
          ))}
        </div>
      )}
      {emojis.length === 0 ? (
        <p className="faint">No emoji match “{query.trim()}”.</p>
      ) : (
        <div className="emoji-grid" role={searching ? 'group' : 'tabpanel'} aria-label={searching ? 'Search results' : group.label}>
          {emojis.map((emoji) => (
            <button
              key={emoji}
              type="button"
              className={`emoji-option${emoji === value ? ' emoji-option-on' : ''}`}
              aria-label={`Pick ${emoji}`}
              aria-pressed={emoji === value}
              onClick={() => onChange(emoji)}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
